export enum SystemAdminDialog {
  ADD_NEW_ROLE = "addNewRole",
  EDIT_ROLE = "editRole",
  DELETE_ROLE = "deleteRole",
}

export enum UserStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}
